import $ from 'jquery';
export default {
	init() {
		function activateTab($tabs, tabKey) {
			var $menu = $tabs.find('.w-tab-menu');
			var $content = $tabs.find('.w-tab-content');
			var $links = $menu.find('[data-w-tab]');
			var $panes = $content.find('[data-w-tab]');

			$links.each(function () {
				var $link = $(this);
				var isActive = $link.attr('data-w-tab') === tabKey;
				$link.toggleClass('w--current', isActive);
				$link.attr('aria-selected', isActive ? 'true' : 'false');
				$link.attr('tabindex', isActive ? '0' : '-1');
			});

			$panes.each(function () {
				var $pane = $(this);
				var isActive = $pane.attr('data-w-tab') === tabKey;
				$pane.toggleClass('w--tab-active', isActive);
			});
		}

		$(document).on('click', '.w-tabs .w-tab-menu [data-w-tab]', function (event) {
			event.preventDefault();
			var $link = $(this);
			var tabKey = $link.attr('data-w-tab');
			var $tabs = $link.closest('.w-tabs');
			if (!tabKey || !$tabs.length) {
				return;
			}
			activateTab($tabs, tabKey);
		});
	},
};
